import { Link } from 'react-router-dom';

export default function DashboardVencimientos({ stros }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const parseDate = (str) => {
    if (!str) return null;
    const [y, m, d] = str.split('-').map(Number);
    return new Date(y, m - 1, d);
  };

  // Filter stros with fechaVencimiento and sort by date
  const strosConVenc = stros
    .filter(s => s.fechaVencimiento)
    .map(s => {
      const fecha = parseDate(s.fechaVencimiento);
      let urgencia = 'proximo';
      if (fecha) {
        fecha.setHours(0, 0, 0, 0);
        if (fecha < today) urgencia = 'vencido';
        else if (fecha.getTime() === today.getTime()) urgencia = 'hoy';
        else if (fecha.getTime() === tomorrow.getTime()) urgencia = 'manana';
      }
      return { ...s, fechaObj: fecha, urgencia };
    })
    .sort((a, b) => {
      // Priority: vencido > hoy > manana > proximo
      const urgOrder = { vencido: 0, hoy: 1, manana: 2, proximo: 3 };
      if (urgOrder[a.urgencia] !== urgOrder[b.urgencia]) {
        return urgOrder[a.urgencia] - urgOrder[b.urgencia];
      }
      return (a.fechaObj || 0) - (b.fechaObj || 0);
    })
    .slice(0, 20); // Show max 20

  const urgenciaLabels = {
    vencido: 'Vencido',
    hoy: 'Hoy',
    manana: 'Mañana',
    proximo: 'Próximo',
  };

  const urgenciaIcons = {
    vencido: 'bi-exclamation-triangle-fill',
    hoy: 'bi-clock-fill',
    manana: 'bi-calendar-event-fill',
    proximo: 'bi-calendar-check-fill',
  };

  const formatFecha = (str) => {
    if (!str) return '';
    const [y, m, d] = str.split('-');
    return `${d}/${m}/${y}`;
  };

  if (strosConVenc.length === 0) {
    return (
      <div className='dashboard-card'>
        <div className='dashboard-card-header'>
          <span className='dashboard-card-title'>
            <i className='bi bi-list-check'></i>
            Próximos Vencimientos
          </span>
        </div>
        <div className='dashboard-empty'>
          <i className='bi bi-calendar-check'></i>
          <p>No hay vencimientos próximos</p>
        </div>
      </div>
    );
  }

  return (
    <div className='dashboard-card'>
      <div className='dashboard-card-header'>
        <span className='dashboard-card-title'>
          <i className='bi bi-list-check'></i>
          Próximos Vencimientos
        </span>
        <span className='dashboard-card-badge'>{strosConVenc.length} casos</span>
      </div>
      <div className='vencimientos-list'>
        {strosConVenc.map((s, idx) => (
          <Link
            to={`/${s.id}`}
            key={s.id || idx}
            className='vencimiento-item'
            style={{ textDecoration: 'none' }}
          >
            <div className={`vencimiento-icon vencimiento-icon--${s.urgencia}`}>
              <i className={`bi ${urgenciaIcons[s.urgencia]}`}></i>
            </div>
            <div className='vencimiento-info'>
              <span className='vencimiento-nro'>
                Stro #{s.nroStro?.toString().slice(3) || s.nroStro}
              </span>
              <span className='vencimiento-detalle'>
                {s.dom || 'Sin dominio'} — {s.nombreAseg || 'Sin asegurado'}
              </span>
              <span className='vencimiento-fecha'>
                <i className='bi bi-calendar3' style={{ marginRight: '4px' }}></i>
                {formatFecha(s.fechaVencimiento)}
              </span>
            </div>
            <span className={`vencimiento-badge vencimiento-badge--${s.urgencia}`}>
              {urgenciaLabels[s.urgencia]}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
